import type { ProgramGuideItem, PlayItem } from "@ca.vmedia.tv/domains";
import {TimeUtils} from "../time";
export class ProgramUtils {

    static isLive(program: ProgramGuideItem | PlayItem): boolean {
        const now = TimeUtils.dateNow();
        const beginTime = program.recentAirTime?.startTime ?? 0;
        const endTime = beginTime + program.length! * 60 * 1000;

        return beginTime <= now && endTime > now;
    }

    static isPast(program: ProgramGuideItem): boolean {
        const now = TimeUtils.dateNow();
        const beginTime = program.recentAirTime!.startTime!;
        const endTime = beginTime + program.length! * 60 * 1000;

        return endTime <= now;
    }

    static isFuture(program: ProgramGuideItem): boolean {
        const now = TimeUtils.dateNow();
        const beginTime = program.recentAirTime!.startTime!;

        return beginTime > now;
    }

    static isEmptyProgram(program: ProgramGuideItem | PlayItem): boolean {
        const scheduleId = program.recentAirTime?.id;
        const startTime = program.recentAirTime?.startTime;

        return scheduleId != null && startTime != null && scheduleId === startTime;
    }

    static findProgramByTime(programs: ProgramGuideItem[], time: number): ProgramGuideItem | null {
        if (!programs || programs.length === 0) {
            return null;
        }

        const coveringProgram = programs.find((program) => {
            const startTime = program.recentAirTime?.startTime;
            const endTime = ProgramUtils.getProgramEndTime(program);

            return endTime !== null && startTime != null && startTime <= time && time < endTime;
        });

        if (coveringProgram) {
            return coveringProgram;
        }

        const getProgramDistance = (program: ProgramGuideItem): number => {
            const startTime = program.recentAirTime?.startTime;

            if (startTime == null) {
                return Number.POSITIVE_INFINITY;
            }

            const endTime = ProgramUtils.getProgramEndTime(program);

            if (endTime !== null && startTime <= time && time < endTime) {
                return 0;
            }

            if (time < startTime) {
                return startTime - time;
            }

            return endTime !== null ? time - endTime : time - startTime;
        };

        return programs.reduce<ProgramGuideItem | null>((nearest, program) => {
            if (nearest === null) {
                return program.recentAirTime?.startTime != null ? program : null;
            }

            const nearestDistance = getProgramDistance(nearest);
            const programDistance = getProgramDistance(program);

            if (programDistance < nearestDistance) {
                return program;
            }

            if (programDistance === nearestDistance) {
                const programStart = program.recentAirTime?.startTime;
                const nearestStart = nearest.recentAirTime?.startTime;

                if (programStart != null && nearestStart != null && programStart >= time && nearestStart < time) {
                    return program;
                }
            }

            return nearest;
        }, null);
    }

    private static getProgramEndTime(program: ProgramGuideItem): number | null {
        const startTime = program.recentAirTime?.startTime;

        if (startTime == null) {
            return null;
        }

        const durationInSeconds = program.lengthInS ?? (program.length != null ? program.length * 60 : 0);

        return durationInSeconds > 0 ? startTime + durationInSeconds * 1000 : null;
    }

    super() {
        return this;
    }
}
